// Сгенерировано firmware-source/tools/export_pwa_palettes.mjs из skins/eva-ui.json. Не редактировать вручную.
// Порядок и id совпадают с EVA_SKIN_CATALOG прошивки; первая палитра — по умолчанию.

export type Palette = { id: string; name: string; bg: string; text: string; dim: string; accent: string; accent2: string };

export const PALETTES: readonly Palette[] = [
  {
    "id": "evrusha",
    "name": "Base",
    "bg": "#323843",
    "text": "#fafafa",
    "dim": "#efede3",
    "accent": "#69a3ff",
    "accent2": "#ffcbeb"
  },
  {
    "id": "bloom",
    "name": "Blesk",
    "bg": "#405408",
    "text": "#ffceaa",
    "dim": "#96a046",
    "accent": "#4696ff",
    "accent2": "#ffb4dc"
  },
  {
    "id": "ember",
    "name": "Sluchilas",
    "bg": "#684000",
    "text": "#fff6dc",
    "dim": "#bea05a",
    "accent": "#d2e628",
    "accent2": "#96d21e"
  },
  {
    "id": "graphite",
    "name": "Smokey",
    "bg": "#2c2820",
    "text": "#f0e8d4",
    "dim": "#968e7c",
    "accent": "#beb6a0",
    "accent2": "#ffffff"
  },
  {
    "id": "mono",
    "name": "Nazovu",
    "bg": "#f6c496",
    "text": "#3c1a06",
    "dim": "#966446",
    "accent": "#c85014",
    "accent2": "#3c1a06"
  },
  {
    "id": "pal_warhol",
    "name": "Andy",
    "bg": "#1394ea",
    "text": "#ffffff",
    "dim": "#96cdf5",
    "accent": "#081434",
    "accent2": "#081434"
  },
  {
    "id": "pal_militantum",
    "name": "Militantum",
    "bg": "#0c0b0a",
    "text": "#c43a2a",
    "dim": "#6e645f",
    "accent": "#dcd7d0",
    "accent2": "#c43a2a"
  },
  {
    "id": "pal_tank",
    "name": "Ludi",
    "bg": "#3a0820",
    "text": "#ff5c7c",
    "dim": "#96375a",
    "accent": "#ffbecd",
    "accent2": "#785fff"
  }
];

export const DEFAULT_PALETTE_ID = "evrusha";
